import {Component, OnDestroy, OnInit} from '@angular/core';
import * as Highcharts from 'highcharts';
import {ContractService} from 'src/app/core/services/contract.service';
import {Message} from 'src/app/core/class/message';
import {Router} from '@angular/router';
import {EnumContractUserRole, EnumContractEnterpriseStatus} from 'src/app/core/constants/contract';

declare var $: any; // ADD THIS
import * as $ from 'jquery';
import {UserService} from 'src/app/core/services/user.service';
import {CommonService} from 'src/app/core/services/common.service';
import {NotificationService} from 'src/app/core/services/notification.service';
import {Subscription} from 'rxjs';
import {MatDatepickerInputEvent} from '@angular/material';
import * as moment from 'moment';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-analysis-report-customer',
  templateUrl: './analysis-report-customer.component.html',
  styleUrls: ['./analysis-report-customer.component.scss']
})
export class AnalysisReportCustomerComponent implements OnInit, OnDestroy {

  isShowWarningExpireDigContract: boolean;
  isShowWarningExpireContractQuantity: boolean;
  isStorageDigContractExpired: boolean = false;
  isContractQuantityExpired: boolean = false;
  storageDigContractExpireTitle = '';
  ContractQuantityExpireTitle = '';
  public subscription: Subscription;
  //Obj Doi Tac
  // partner = {
  //   totalDocumentsWaitingForProgressing: null,
  //   totalDocumentsFinish: null,
  //   totalDocumentsDenied: null
  // }
  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;
  me: any;


  //DEFAULT LINKS
  SEARCH_SIGNATURE_WAITING_LINK = '/home-enterprise/search-document-sign';
  SEARCH_APPROVAL_WAITING_LINK = '/home-enterprise/search-approval-waiting-document';
  SEARCH_INITIAL_WAITING_LINK = '/home-enterprise/search-initial-waiting-document';
  SEARCH_RECEIVED_DOCUMENT_LINK = '/home-enterprise/search-document-receive/';

  documentEnterpriseReceive = {
    waitSetSignFlow: 0,
    processing: 0,
    rejected: 0,
    signed: 0
  };

  isShowWarningConsumptionFromDate: boolean;
  isShowWarningConsumptionToDate: boolean;
  optionsSelect = 1;

  //Khoi tao chart
  highcharts = Highcharts;
  chartOptionsUserHandle: any;
  consumptionFormGroup: FormGroup;
  defaultModelCreateTime = {
    createdTimeFrom: moment().subtract(30, 'd').format('YYYY-MM-DD'),
    createdTimeTo: moment(new Date()).format('YYYY-MM-DD')
  };

  constructor(
    public datepipe: DatePipe,
    private contractService: ContractService,
    private message: Message,
    private router: Router,
    private userService: UserService,
    private commonService: CommonService,
    private notificationService: NotificationService,
    private formBuilder: FormBuilder,
  ) {
    this.isShowWarningExpireDigContract = false;
    this.isShowWarningExpireContractQuantity = false;
  }

  ngOnInit() {
    this.getDataCountNumberDocumentOfPartner();
    this.getDataCountNumberDocumentOfEnterpriseByService();
    this.getMe();
    this.consumptionFormGroup = this.formBuilder.group({
      fromDate: [
        moment(this.defaultModelCreateTime.createdTimeFrom).format('YYYY-MM-DD'),
        [Validators.required]
      ],
      toDate: [
        moment(this.defaultModelCreateTime.createdTimeTo).format('YYYY-MM-DD'),
        [Validators.required]
      ],
    });

    this.subscription = this.notificationService.changePassword.subscribe((data) => {
      if (data) {
        this.getMe();
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit() {
  }

  getMe() {
    const dayToExpire = +localStorage.getItem('dayToExpire');
    // console.log("getMe customer " + this.dayToExpire);
    const numberDayShowWarningPassword = localStorage.getItem('numberDayShowWarningPassword') == 'undefined' ? 10 : +localStorage.getItem('numberDayShowWarningPassword');

    this.me = {
      messagePasswordExpired: +dayToExpire < 1 ? (+dayToExpire == 0 ? this.message.getMessage('analysis.analysis_report_enterprise.notify_password_expire_today') : this.message.getMessage('messages.expired_password')) : this.commonService.format(this.message.getMessage('analysis.analysis_report_enterprise.notify_password_expire'), dayToExpire),
      isWarning: +dayToExpire <= numberDayShowWarningPassword ? true : false
    };
    // console.log(this.me);

    if (this.me.isWarning && this.me.messagePasswordExpired == '') {
      this.me = {
        ...this.me,
        messagePasswordExpired: +dayToExpire == 0 ? 'Mật khẩu của đơn vị SẼ HẾT HẠN trong hôm nay, vui lòng thực hiện đổi mật khẩu để tiếp tục sử dụng' : `Mật khẩu của đơn vị SẼ HẾT HẠN sau ${dayToExpire} ngày, vui lòng thực hiện đổi mật khẩu để tiếp tục sử dụng`,
      };
    }
  }

  // Đối tác
  getDataCountNumberDocumentOfPartner() {
    const params = {
      fromDate: this.datepipe.transform(moment(this.defaultModelCreateTime.createdTimeFrom).startOf('day').toISOString(), 'yyyy-MM-dd'),
      toDate: this.datepipe.transform(moment(this.defaultModelCreateTime.createdTimeTo).endOf('day').toISOString(), 'yyyy-MM-dd')
    };
    this.contractService.getDataCountNumberDocumentOfPartnerService(params).subscribe(
      response => {
        let {
          statisticDocumentEnterpriseReceive,
          statisticDocumentUsersHandle
        } = response.data;

        statisticDocumentEnterpriseReceive = statisticDocumentEnterpriseReceive || [];
        statisticDocumentUsersHandle = statisticDocumentUsersHandle || [];
        this.documentEnterpriseReceive.processing = this.getAmountByStatus(2, statisticDocumentEnterpriseReceive);
        this.documentEnterpriseReceive.rejected = this.getAmountByStatus(3, statisticDocumentEnterpriseReceive);
        this.documentEnterpriseReceive.signed = this.getAmountByStatus(4, statisticDocumentEnterpriseReceive);
        this.documentEnterpriseReceive.waitSetSignFlow = this.getAmountByStatus(6, statisticDocumentEnterpriseReceive);

        const userHandleData = [
          {
            name: this.message.getMessage('left_menu.enterprise_waiting_initial_doc'),
            y: this.getAmountByStatus(EnumContractUserRole.INITIAL, statisticDocumentUsersHandle),
            drilldown: this.message.getMessage('left_menu.enterprise_waiting_initial_doc'),
            url: this.SEARCH_INITIAL_WAITING_LINK,
            router: this.router,
            fromDate: params.fromDate,
            toDate: params.toDate
          },
          {
            name: this.message.getMessage('left_menu.enterprise_waiting_approve_doc'),
            y: this.getAmountByStatus(EnumContractUserRole.APPROVE, statisticDocumentUsersHandle),
            drilldown: this.message.getMessage('left_menu.enterprise_waiting_approve_doc'),
            url: this.SEARCH_APPROVAL_WAITING_LINK,
            router: this.router,
            fromDate: params.fromDate,
            toDate: params.toDate
          },
          {
            name: this.message.getMessage('left_menu.enterprise_waiting_signing_doc'),
            y: this.getAmountByStatus(EnumContractUserRole.SIGN, statisticDocumentUsersHandle),
            drilldown: this.message.getMessage('left_menu.enterprise_waiting_signing_doc'),
            url: this.SEARCH_SIGNATURE_WAITING_LINK,
            router: this.router,
            fromDate: params.fromDate,
            toDate: params.toDate
          }
        ];

        this.UserHandleColumnChart(userHandleData, this.message.getMessage('analysis.no_data'));

        //console.log("PARTNER:", response.data);
        // if (Object.keys(response.data).length !== 0 && response.data.constructor === Object) {
        //   this.partner.totalDocumentsWaitingForProgressing = response.data.totalDocumentsWaitingForProgressing;
        //   this.partner.totalDocumentsFinish = response.data.totalDocumentsFinish;
        //   this.partner.totalDocumentsDenied = response.data.totalDocumentsDenied;
        // }
        // else {
        //   this.partner.totalDocumentsWaitingForProgressing = 0;
        //   this.partner.totalDocumentsFinish = 0;
        //   this.partner.totalDocumentsDenied = 0;
        // }
      }
    );
  }

  getAmountByStatus(status, data) {
    const amountdata = data.filter(item => item.status == status);
    if (amountdata.length == 0) {
      return 0;
    }
    return amountdata[0].amount;
  }

  UserHandleColumnChart(data, langNodata) {
    this.chartOptionsUserHandle = {
      chart: {
        type: 'column',
        //renderTo: 'container',
        //margin: [50, 50, 100, 80]
        // events: {
        //   load: function () {
        //     if (data[0].y == 0 && data[1].y == 0 && data[2].y == 0) {
        //       $("#user-handle").empty();
        //       $("#user-handle").append('<div class="no-data-chart"><img alt="time" src="./assets/images/no-data-chart.svg" width="100" height="100"><span>' + langNodata + '</span></div>');
        //     }
        //   }
        // }
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      subtitle: {
        text: ''
      },
      accessibility: {
        announceNewData: {
          enabled: true
        }
      },
      xAxis: {
        type: 'category',
        labels: {
          rotation: -45,
          style: {
            fontSize: '12px',
            fontFamily: 'Roboto, "Helvetica Neue", sans-serif',
            color: 'black'
          }
        }
      },
      yAxis: {
        title: {
          text: ''
        },
        labels: {
          style: {
            fontSize: '12px',
            fontFamily: 'Roboto, "Helvetica Neue", sans-serif',
            color: 'black'
          }
        }

      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            crop: false,
            overflow: 'none',
            format: '{point.y}',
            style: {
              color: 'black',
              fontWeight: 'normal',
              fontSize: '14px',
              fontFamily: 'Roboto, "Helvetica Neue", sans-serif'
            }
          },
          pointWidth: 50,
          point: {
            events: {
              click: function() {
                this.options.router.navigate([this.options.url], {state: {key: 'analysis-report-enterprise'}});
                // return location.href = this.options.url;
                //return window.open(this.options.url + '/?status=' + this.options.value, '_blank');
              }
            }
          },
          cursor: 'pointer',
          states: {
            hover: {
              color: '#0065FF' // darken
            }
          }
        }
      },
      tooltip: {
        shared: true,
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>',
        style: {
          fontSize: '13px',
          color: 'black',
        }
      },
      series: [
        {
          name: '',
          showInLegend: false,
          data: data,
          //colorByPoint: true,
          color: '#3473B5',
          fontFamily: 'Roboto, "Helvetica Neue", sans-serif'
        }
      ],
      exporting: {
        // sourceWidth: 610,
        // sourceHeight: 390,
      },
      noData: {
        style: {
          fontWeight: 'bold',
          fontSize: '14px',
          color: '#303030',
        }
      }
    };
  }

  onClickPageNavigationDetailItem(item) {
    const params = {
      fromDate: this.datepipe.transform(moment(this.defaultModelCreateTime.createdTimeFrom).startOf('day').toISOString(), 'yyyy-MM-dd'),
      toDate: this.datepipe.transform(moment(this.defaultModelCreateTime.createdTimeTo).endOf('day').toISOString(), 'yyyy-MM-dd')
    };
    // return location.href = "home-enterprise/search-document-receive?status=" + item;
    this.router.navigate([this.SEARCH_RECEIVED_DOCUMENT_LINK, {}], {
      queryParams: {
        progressStatus: item,
        receivedTimeFrom: params.fromDate,
        receivedTimeTo: params.toDate
      }
    });
  }

  //Doanh nghiệp mua Dịch vụ
  getDataCountNumberDocumentOfEnterpriseByService() {

    let configManualBccs: any;
    this.contractService.getDataCountNumberDocumentOfEnterpriseByService().subscribe(
      response => {
        console.log('ENTERPRISE BY SERVICE:', response.data);
        if (Object.keys(response.data).length !== 0 && response.data.constructor === Object) {

          // Check hết hạn hợp đồng không
          if (response.data.expireDateContractQuantity !== undefined && response.data.expireDateContractQuantity !== null && this.isExpiredDate(response.data.expireDateContractQuantity)) {
            this.isContractQuantityExpired = true;
          } else {
            this.isContractQuantityExpired = false;
            this.ContractQuantityExpireTitle = this.formatDate(new Date(response.data.expireDateContractQuantity));
          }

          // Check hết hạn số hóa không
          if (response.data.expireDateStorageDigContract !== undefined && response.data.expireDateStorageDigContract !== null && this.isExpiredDate(response.data.expireDateStorageDigContract)) {
            this.isStorageDigContractExpired = true;
          } else {
            this.isStorageDigContractExpired = false;
            this.storageDigContractExpireTitle = this.formatDate(new Date(response.data.expireDateStorageDigContract));
          }
          this.isShowWarningExpireDigContract = response.data.warningStorageDigContractExpire;
          this.isShowWarningExpireContractQuantity = response.data.warningContractQuantityExpire;
        }
      }
    );
  }

  padTo2Digits(num): string {
    return num.toString().padStart(2, '0');
  }

  formatDate(date): string {
    const a = this.padTo2Digits(date.getDate()) + '/' + this.padTo2Digits(date.getMonth() + 1) + '/' + date.getFullYear();
    console.log('AAAA', a);
    return a;
    // return [
    //   this.padTo2Digits(date.getDate()),
    //   this.padTo2Digits(date.getMonth() + 1),
    //   date.getFullYear(),
    // ].join('"\/');
  }


  isExpiredDate(date: any): boolean {
    const currentTime = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    const expireTime = new Date(date);
    if (currentTime >= expireTime) {
      return true;
    } else {
      return false;
    }
  }

  resetDateForChangeSelect(option) {
    this.isShowWarningConsumptionFromDate = false;
    this.isShowWarningConsumptionToDate = false;
    const currentCreatedTimeFromInput = moment(this.defaultModelCreateTime.createdTimeFrom).format('YYYY-MM-DD');
    const currentCreatedTimeToInput = moment(this.defaultModelCreateTime.createdTimeTo).format('YYYY-MM-DD');

    if (option === 1) {          // day
      const maxAllowCreatedTimeTo = moment(currentCreatedTimeFromInput).add(30, 'd').format('YYYY-MM-DD');
      if (!moment(currentCreatedTimeToInput).isBetween(moment(currentCreatedTimeFromInput), moment(maxAllowCreatedTimeTo), undefined, '[]')) {
        this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo;
      }
    }

    if (option === 2) {          // week
      const maxAllowCreatedTimeTo = moment(currentCreatedTimeFromInput).add(10, 'weeks').subtract(1, 'd').format('YYYY-MM-DD');
      if (!moment(currentCreatedTimeToInput).isBetween(moment(currentCreatedTimeFromInput), moment(maxAllowCreatedTimeTo), undefined, '[]')) {
        this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo;
      }
    }

    if (option === 3) {          // month
      const maxAllowCreatedTimeTo = moment(currentCreatedTimeFromInput).add(12, 'months').subtract(1, 'd').format('YYYY-MM-DD');
      if (!moment(currentCreatedTimeToInput).isBetween(moment(currentCreatedTimeFromInput), moment(maxAllowCreatedTimeTo), undefined, '[]')) {
        this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo;
      }
    }

    if (option === 4) {          // quarter
      const maxAllowCreatedTimeTo = moment(currentCreatedTimeFromInput).add(10, 'quarters').subtract(1, 'd').format('YYYY-MM-DD');
      if (!moment(currentCreatedTimeToInput).isBetween(moment(currentCreatedTimeFromInput), moment(maxAllowCreatedTimeTo), undefined, '[]')) {
        this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo;
      }
    }

    if (option === 5) {          // year
      const maxAllowCreatedTimeTo = moment(currentCreatedTimeFromInput).add(10, 'years').subtract(1, 'd').format('YYYY-MM-DD');
      if (!moment(currentCreatedTimeToInput).isBetween(moment(currentCreatedTimeFromInput), moment(maxAllowCreatedTimeTo), undefined, '[]')) {
        this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo;
      }
    }

    this.consumptionFormGroup = this.formBuilder.group({
      fromDate: [moment(this.defaultModelCreateTime.createdTimeFrom).format('YYYY-MM-DD'), [Validators.required]],
      toDate: [moment(this.defaultModelCreateTime.createdTimeTo).format('YYYY-MM-DD'), [Validators.required]],
    });
  }

  changeDatePickerFromDate(type: string, event: MatDatepickerInputEvent<Date>) {
    this.isShowWarningConsumptionFromDate = false;
    this.isShowWarningConsumptionToDate = false;
    if (event.value === null) {
      return;
    }
    // this.isValidFormDate = true;
    this.defaultModelCreateTime.createdTimeFrom = moment(event.value).format('YYYY-MM-DD');

    // re-calculate value of timeTo
    if (!moment(this.defaultModelCreateTime.createdTimeTo).isSameOrAfter(moment(event.value), undefined)) {
      this.defaultModelCreateTime.createdTimeTo = moment(event.value).format('YYYY-MM-DD');
    }
    const currentCreatedTimeToInput = moment(this.defaultModelCreateTime.createdTimeTo);

    // day
    if (this.optionsSelect === 1) {
      const maxAllowCreatedTimeTo = moment(event.value).add(30, 'd');
      if (!currentCreatedTimeToInput.isBetween(moment(event.value), maxAllowCreatedTimeTo, undefined, '[]')) {
        this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo.format('YYYY-MM-DD');
        this.isShowWarningConsumptionFromDate = true;
      }
    }

    // week
    if (this.optionsSelect === 2) {
      const maxAllowCreatedTimeTo = moment(event.value).add(10, 'weeks').subtract(1, 'd');
      if (!currentCreatedTimeToInput.isBetween(moment(event.value), maxAllowCreatedTimeTo, undefined, '[]')) {
        this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo.format('YYYY-MM-DD');
        this.isShowWarningConsumptionFromDate = true;
      }
    }

    // month
    if (this.optionsSelect === 3) {
      const maxAllowCreatedTimeTo = moment(event.value).add(12, 'months').subtract(1, 'd');
      if (!currentCreatedTimeToInput.isBetween(moment(event.value), maxAllowCreatedTimeTo, undefined, '[]')) {
        this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo.format('YYYY-MM-DD');
        this.isShowWarningConsumptionFromDate = true;
      }
    }

    // quarter
    if (this.optionsSelect === 4) {
      const maxAllowCreatedTimeTo = moment(event.value).add(10, 'quarters').subtract(1, 'd');
      if (!currentCreatedTimeToInput.isBetween(moment(event.value), maxAllowCreatedTimeTo, undefined, '[]')) {
        this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo.format('YYYY-MM-DD');
        this.isShowWarningConsumptionFromDate = true;
      }
    }

    // year
    if (this.optionsSelect === 5) {
      const maxAllowCreatedTimeTo = moment(event.value).add(10, 'years').subtract(1, 'd');
      if (!currentCreatedTimeToInput.isBetween(moment(event.value), maxAllowCreatedTimeTo, undefined, '[]')) {
        this.defaultModelCreateTime.createdTimeTo = maxAllowCreatedTimeTo.format('YYYY-MM-DD');
        this.isShowWarningConsumptionFromDate = true;
      }
    }

    this.consumptionFormGroup = this.formBuilder.group({
      fromDate: [moment(this.defaultModelCreateTime.createdTimeFrom).format('YYYY-MM-DD'), [Validators.required]],
      toDate: [moment(this.defaultModelCreateTime.createdTimeTo).format('YYYY-MM-DD'), [Validators.required]],
    });

    this.getDataCountNumberDocumentOfPartner();
  }

  changeDatePickerToDate(type: string, event: MatDatepickerInputEvent<Date>) {
    this.isShowWarningConsumptionToDate = false;
    this.isShowWarningConsumptionFromDate = false;
    if (event.value === null) {
      return;
    } else {
      this.defaultModelCreateTime.createdTimeTo = moment(event.value).format('YYYY-MM-DD');

      // re-calculate value of timeFrom
      if (!moment(this.defaultModelCreateTime.createdTimeFrom).isSameOrBefore(moment(event.value), undefined)) {
        this.defaultModelCreateTime.createdTimeFrom = moment(event.value).format('YYYY-MM-DD');
      }
      const currentCreatedTimeFromInput = moment(this.defaultModelCreateTime.createdTimeFrom);

      // day
      if (this.optionsSelect === 1) {
        const minAllowCreatedTimeFrom = moment(event.value).subtract(30, 'd');
        if (!currentCreatedTimeFromInput.isBetween(minAllowCreatedTimeFrom, moment(event.value), undefined, '[]')) {
          this.defaultModelCreateTime.createdTimeFrom = minAllowCreatedTimeFrom.format('YYYY-MM-DD');
          this.isShowWarningConsumptionToDate = true;
        }
      }

      // week
      if (this.optionsSelect === 2) {
        const minAllowCreatedTimeFrom = moment(event.value).subtract(10, 'weeks').add(1, 'd');
        if (!currentCreatedTimeFromInput.isBetween(minAllowCreatedTimeFrom, moment(event.value), undefined, '[]')) {
          this.defaultModelCreateTime.createdTimeFrom = minAllowCreatedTimeFrom.format('YYYY-MM-DD');
          this.isShowWarningConsumptionToDate = true;
        }
      }

      // month
      if (this.optionsSelect === 3) {
        const minAllowCreatedTimeFrom = moment(event.value).subtract(12, 'months').add(1, 'd');
        if (!currentCreatedTimeFromInput.isBetween(minAllowCreatedTimeFrom, moment(event.value), undefined, '[]')) {
          this.defaultModelCreateTime.createdTimeFrom = minAllowCreatedTimeFrom.format('YYYY-MM-DD');
          this.isShowWarningConsumptionToDate = true;
        }
      }

      // quarter
      if (this.optionsSelect === 4) {
        const minAllowCreatedTimeFrom = moment(event.value).subtract(10, 'quarters').add(1, 'd');
        if (!currentCreatedTimeFromInput.isBetween(minAllowCreatedTimeFrom, moment(event.value), undefined, '[]')) {
          this.defaultModelCreateTime.createdTimeFrom = minAllowCreatedTimeFrom.format('YYYY-MM-DD');
          this.isShowWarningConsumptionToDate = true;
        }
      }

      // year
      if (this.optionsSelect === 5) {
        const minAllowCreatedTimeFrom = moment(event.value).subtract(10, 'years').add(1, 'd');
        if (!currentCreatedTimeFromInput.isBetween(minAllowCreatedTimeFrom, moment(event.value), undefined, '[]')) {
          this.defaultModelCreateTime.createdTimeFrom = minAllowCreatedTimeFrom.format('YYYY-MM-DD');
          this.isShowWarningConsumptionToDate = true;
        }
      }

      this.consumptionFormGroup = this.formBuilder.group({
        fromDate: [moment(this.defaultModelCreateTime.createdTimeFrom).format('YYYY-MM-DD'), [Validators.required]],
        toDate: [moment(this.defaultModelCreateTime.createdTimeTo).format('YYYY-MM-DD'), [Validators.required]],
      });
      // this.getDataConsumptionHistory(this.optionsSelect);
      // this.getDataCountNumberDocument();
      this.getDataCountNumberDocumentOfPartner();
    }
  }

  getErrorDateMessageRange(pickerInput: string, isExpired?: boolean): string {
    // console.log("pickerInput: ", pickerInput)
    if (!pickerInput || pickerInput === '') {
      return null;
    }
    return this.message.getMessage('validation.format_of_date_consumption');
  }

  keyupEnterSelected() {
    setTimeout(() => {
      this.getDataCountNumberDocumentOfPartner();
    }, 200);
  }

  onChangeSelect(optionsSelect) {
    this.resetDateForChangeSelect(optionsSelect);
  }

}

